//./src/pages/GoogleRegister.js
import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { googleRegister } from "../services/GoogleRegister";
import { loginUser } from "../services/login";
import { getMe } from "../services/session";
import { STORAGE_KEYS } from "../config/vars";
import "../styles/auth.css";

const GoogleRegister = () => {
    const [form, setForm] = useState({ name: "", email: "", descriptions: "", password: "", service_ids: [] });
    const [googleToken, setGoogleToken] = useState("");
    const [message, setMessage] = useState("");
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (googleToken) return;
        const hashParams = new URLSearchParams((location.hash || "").replace(/^#/, ""));
        // Security: only accept registration token/name/email from URL hash, never from query string.
        const token = hashParams.get("token");
        const resolvedName = hashParams.get("name");
        const resolvedEmail = hashParams.get("email");

        if (token && resolvedName && resolvedEmail) {
            setForm((prev) => ({ ...prev, name: resolvedName, email: resolvedEmail }));
            localStorage.setItem("emailForGoogle", resolvedEmail);
            setGoogleToken(token);

            // Remove the token from the address bar (keeps it out of screenshots/copy-paste/history as much as possible).
            try {
                window.history.replaceState({}, document.title, location.pathname);
            } catch (_) {
                // ignore
            }
        } else {
            setMessage("❌ Дані з Google не отримані");
        }
    }, [location, googleToken]);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleAutoLogin = async () => {
        try {
            const { ok, data } = await loginUser({ email: form.email, password: form.password });
            if (!ok) {
                setMessage("⚠️ Помилка автоматичного входу: " + (data.detail || "Невідома помилка"));
                return;
            }

            const me = await getMe();
            if (!me) {
                setMessage("⚠️ Не вдалося підтвердити сесію після входу");
                return;
            }

            if (me.client_id) localStorage.setItem("clientId", me.client_id);
            if (me.name) localStorage.setItem("clientName", me.name);
            if (me.email) localStorage.setItem("emailForGoogle", me.email);
            const forceFlag = me.force_password_change ? "true" : "false";
            localStorage.setItem("forcePasswordChange", forceFlag);
            localStorage.setItem("locationId", me.location_id || "");
            localStorage.setItem("networkId", me.network_id || "");
            if (me.active_context_id !== undefined && me.active_context_id !== null) {
                localStorage.setItem(STORAGE_KEYS.ACTIVE_CLIENT_CONTEXT_ID, me.active_context_id);
            }

            const deviceId = localStorage.getItem("deviceId");
            navigate(deviceId ? `/main?device_id=${deviceId}` : "/main");
        } catch (error) {
            setMessage("⚠️ Збій при вході: " + error.message);
        }
    };

    const handleRegister = async () => {
        if (!googleToken) {
            setMessage("❌ Немає токена Google-реєстрації");
            return;
        }

        const { ok, data } = await googleRegister({
            token: googleToken,
            descriptions: form.descriptions,
            password: form.password,
            service_ids: form.service_ids,
        });

        if (ok) {
            setMessage("✅ Реєстрація успішна, вхід виконується...");
            // тут одразу логінимо
            setTimeout(() => handleAutoLogin(), 1000);
        } else {
            setMessage("❌ " + (data.detail || "Помилка реєстрації через Google"));
        }
    };

    return (
        <div className="auth-container">
            <div className="auth-form">
                <h2>Завершіть реєстрацію</h2>
                <p>Підтверджено через Google. Залишилось ввести пароль.</p>

                <input
                    type="text"
                    name="name"
                    value={form.name}
                    onChange={handleChange}
                    disabled
                    className="input-field"
                />
                <input
                    type="email"
                    name="email"
                    value={form.email}
                    onChange={handleChange}
                    disabled
                    className="input-field"
                />
                <input
                    type="text"
                    name="descriptions"
                    value={form.descriptions}
                    onChange={handleChange}
                    placeholder="Опис (наприклад, адреса)"
                    className="input-field"
                />
                <label>
                    Пароль<span style={{ color: "red" }}>*</span>
                </label>
                <input
                    type="password"
                    name="password"
                    value={form.password}
                    onChange={handleChange}
                    placeholder="Пароль"
                    className="input-field"
                />

                <button onClick={handleRegister} className="action-btn">Завершити</button>

                {message && <p className="message">{message}</p>}
            </div>
        </div>
    );
};

export default GoogleRegister;
